import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { Portfolio } from "@/components/site/Portfolio";
import { ClientMarquee } from "@/components/site/ClientMarquee";
import { About } from "@/components/site/About";
import { Testimonials } from "@/components/site/Testimonials";
import { ReviewsSection } from "@/components/site/ReviewsSection";
import { ContactCTA } from "@/components/site/ContactCTA";
import { CalendlyInline } from "@/components/site/CalendlyEmbed";
import { GMBSection } from "@/components/site/GMBSection";
import { Footer } from "@/components/site/Footer";
import { SEO } from "@/components/site/SEO";
import { ROUTE_SEO } from "@/lib/routeSeo";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-background text-foreground">
      <SEO
        title={ROUTE_SEO["/"].title}
        description={ROUTE_SEO["/"].meta}
        path="/"
      />
      <Header />
      <main>
        <h1 className="sr-only">{ROUTE_SEO["/"].h1}</h1>
        <Hero />
        <Services />
        <Portfolio />
        <ClientMarquee />
        <About />
        <Testimonials />
        <ReviewsSection />
        <GMBSection />
        <ContactCTA />
        <CalendlyInline kicker="Or skip the form" title="Grab a 15-min slot instead." subtitle="Prefer to talk it through? Book a quick discovery call and we'll walk through your project together." />
      </main>
      <Footer />
    </div>
  );
}
